import { Location } from 'react-router';

import { isSSG } from 'modules/common/utils/isSSG';
import { PATH_SETTINGS } from 'domains/userSettings/Routes';

import { getSearchEmailParam } from './hasEmailChangeParam';

export const isInvitation = (location: Location) => {
  const { pathname = '', search = '' } = location || {};

  const isSettingsPath =
    pathname.split('/').join('') === PATH_SETTINGS.split('/').join('');

  const hasEmailParam = isSSG() ? false : getSearchEmailParam(search);

  return isSettingsPath && hasEmailParam;
};
